__webpack_require__.p = "/interactive/morganstanley/evolution-of-spacesuit-design/";